<template>
  <v-row no-gutters>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-smoking</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_smoking') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_smoking }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-briefcase</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_occupation') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_occupation }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-paw</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_pets') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_pets }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-gender-male-female</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_gender') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_gender }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_age') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_age }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-translate</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_language') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_language }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar :size="30">
          <v-icon dark color="primary">mdi-account-group</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ trans('advert.tenant_couples') }}</v-list-item-title>
          <v-list-item-subtitle>{{ tenant_couples }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";

export default {
  props: ["advert"],
  computed: {
    tenant_smoking: function() {
      let val = _.get(this.$props.advert, "tenant_smoking", null);
      if (val) return this.trans(`advert.tenant_smoking_${val}`);
      return "—";
    },
    tenant_occupation: function() {
      let val = _.get(this.$props.advert, "tenant_occupation", null);

      if (val) return this.trans(`advert.tenant_occupation_${val}`);
      return "—";
    },
    tenant_pets: function() {
      let val = _.get(this.$props.advert, "tenant_pets", null);
      if (val) return this.trans(`advert.tenant_pets_${val}`);
      return "—";
    },
    tenant_gender: function() {
      let val = _.get(this.$props.advert, "tenant_gender", null);
      if (val) return this.trans(`advert.tenant_gender_${val}`);
      return "—";
    },
    tenant_age: function() {
      let min = _.get(this.$props.advert, "tenant_age_min", null);
      let max = _.get(this.$props.advert, "tenant_age_max", null);
      return `${min} — ${max}`; // @todo if 0 - 0
    },
    tenant_language: function() {
      let val = _.get(this.$props.advert, "tenant_language", null);
      if (val) return this.trans(`advert.tenant_language_${val}`);
      return "—";
    },
    tenant_couples: function() {
      let val = _.get(this.$props.advert, "tenant_couples", null);
      if (val) return this.trans(`advert.tenant_couples_${val}`);
      return "—";
    }
  }
};
</script>